import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate credential ID
  if (!properties.credential || typeof properties.credential !== 'string') {
    errors.push({ key: 'credential', message: 'Data Engine Credential is required' });
  } else if (properties.credential.trim().length === 0) {
    errors.push({ key: 'credential', message: 'Data Engine Credential cannot be empty' });
  }

  // Validate table ID
  if (!properties.tableId || typeof properties.tableId !== 'string') {
    errors.push({ key: 'tableId', message: 'Table ID is required' });
  } else if (properties.tableId.trim().length === 0) {
    errors.push({ key: 'tableId', message: 'Table ID cannot be empty' });
  }

  // Validate API version
  if (!properties.apiVersion || typeof properties.apiVersion !== 'string') {
    errors.push({ key: 'apiVersion', message: 'API Version is required' });
  } else if (properties.apiVersion.trim().length === 0) {
    errors.push({ key: 'apiVersion', message: 'API Version cannot be empty' });
  }

  // Validate page
  if (properties.page === undefined || properties.page === null) {
    errors.push({ key: 'page', message: 'Page is required' });
  } else if (typeof properties.page !== 'number' || properties.page < 1) {
    errors.push({ key: 'page', message: 'Page must be a number greater than or equal to 1' });
  }

  // Validate page size
  if (properties.pageSize === undefined || properties.pageSize === null) {
    errors.push({ key: 'pageSize', message: 'Page Size is required' });
  } else if (typeof properties.pageSize !== 'number' || properties.pageSize < 1) {
    errors.push({ key: 'pageSize', message: 'Page Size must be a number greater than or equal to 1' });
  }

  // Validate max rows
  if (properties.maxRows === undefined || properties.maxRows === null) {
    errors.push({ key: 'maxRows', message: 'Maximum Rows is required' });
  } else if (typeof properties.maxRows !== 'number' || properties.maxRows < 0) {
    errors.push({ key: 'maxRows', message: 'Maximum Rows must be a number greater than or equal to 0' });
  }

  // Validate body if provided
  if (properties.body && typeof properties.body === 'string' && properties.body.trim().length > 0) {
    try {
      JSON.parse(properties.body);
    } catch (e) {
      errors.push({ key: 'body', message: 'Request Body must be valid JSON' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
